import React from 'react'
import { connect } from 'react-redux'
import Button from '@material-ui/core/Button'
import Collapse from '@material-ui/core/Collapse'
import MaterialCard from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import { ExpandLess, ExpandMore } from '@material-ui/icons'
import { css } from 'emotion'

import { getCurrentAppData } from '../../utils/fractalApps'
import { setLang } from '../../store/auth/actions'

const mapDispatchToProps = {
  setLang
}

const selectStyle = css`
  background-color: white;
  display: flex;
  flex-direction: column;
  & > div {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: 10px;
    z-index: 3;
    &:hover {
      background-color: #DEDEDE;
    }
  }
`

const LanguageSelector = (props) => {
  const { setLang, lang } = props
  const [open, setOpen] = React.useState()
  const primaryColor = (getCurrentAppData() && getCurrentAppData().theme) ? getCurrentAppData().theme.primaryColor : '#878787'
  const getLabel = {
    'es': 'es-PY',
    'pt-BR': 'pt-BR',
    'pt-PT': 'pt-PT'
  }
  return (
    <MaterialCard
      style={{
        position: 'absolute',
        top: '1em',
        right: '1em',
        zIndex: 5
      }}
    >
      <CardHeader
        style={{
          borderBottom: `1px solid ${primaryColor}`,
          padding: '10px 10px 5px'
        }}
        action={
          <Button
            style={{
              backgroundColor: 'white',
              fontWeight: 'bold'
            }}
            onClick={() => setOpen(!open)}
            endIcon={open ? <ExpandLess /> : <ExpandMore />}
          >
            <span>{getLabel[lang]}</span>
          </Button>

        }
      />
      <Collapse in={open} >
        <div css={selectStyle}>
          <div
            onClick={() => {
              setLang({ lang: 'pt-BR' })
              setOpen(false)
            }}
          >
            <span
              style={{ cursor: 'pointer', color: primaryColor, fontWeight: 'bold' }}
            >
              pt-BR
            </span>
          </div>
          <div
            onClick={() => {
              setLang({ lang: 'es' })
              setOpen(false)
            }}
          >
            <span
              style={{ cursor: 'pointer', color: primaryColor, fontWeight: 'bold' }}
            >
              es-PY
            </span>
          </div>
          <div
            onClick={() => {
              setLang({ lang: 'pt-PT' })
              setOpen(false)
            }}
          >
            <span
              style={{ cursor: 'pointer', color: primaryColor, fontWeight: 'bold' }}
            >
              pt-PT
            </span>
          </div>
        </div>
      </Collapse>
    </MaterialCard>

  )
}

export default connect(null, mapDispatchToProps)(LanguageSelector)
